import type * as NavigationMenu from '@radix-ui/react-navigation-menu'
import Link from 'next/link'

import Icon, { type IconPropsType } from '@/legacy-src/components/icons/Icon'

import { LinkTag } from '@/src/domains/design-system/components/Tag'
import { Text } from '@/src/domains/design-system/components/Text'
import type { HeaderSubNavigationType } from '@/src/domains/header/components/Header/Header.constants'
import { HeaderBasicNavigationLink } from '@/src/domains/header/components/Header/HeaderBasicNavigationLink'

export interface HeaderSubNavigationLinkProps
  extends Omit<NavigationMenu.NavigationMenuLinkProps, 'onSelect' | 'href'> {
  href: string
  type?: `${HeaderSubNavigationType}`
  iconColor?: IconPropsType['color']
}

export const HeaderSubNavigationLink = ({
  type = 'default',
  iconColor = 'primary',
  ...props
}: HeaderSubNavigationLinkProps) =>
  type === 'tags' ? (
    <HeaderBasicNavigationLink asChild>
      <LinkTag variant="white" size="m" {...props} />
    </HeaderBasicNavigationLink>
  ) : (
    <Text asChild>
      <HeaderBasicNavigationLink asChild>
        <Link className="flex items-center gap-3 text-secondary hover:text-secondary" {...props}>
          <Icon icon="arrows-beak" size={24} color={iconColor} className="shrink-0 -rotate-90 tablet:text-primary" />
          {props.children}
        </Link>
      </HeaderBasicNavigationLink>
    </Text>
  )
